import { Fragment, useEffect, useRef, useState } from "react";
import Dropdown from "../../../../../utils/component/dropdown/dropDown.index";
import TextInput from "../../../../../utils/component/textInput/textInput.index";
import CheckBox from "../../../../../utils/component/checkbox/checkbox.index";
import Button from "../../../../../utils/component/button/button.index";
import { ButtonType } from "../../../../../utils/component/button/button.interface";
import FolderLocationModal from "../folderLocationModal/folderLocationModal.index";
import { useNavigate } from "react-router-dom";
import { AdvencedSearchInterface } from "./advancedSearch.inteface";
import PATH from "../../../../../urls/path";
import Drawer from "../../../../../utils/component/drawer/drawer.index";
import moment from "moment-jalaali";
import { Listbox, Transition } from "@headlessui/react";
import { ReactComponent as CaretUp } from "../../../../../assets/images/icons/CaretUp.svg";
import Calendar from "../../../../../utils/component/calendar2/calendar.index";
import { CalendarOptions, SearchPageType } from "../search.interface";
import { dateRangeCheck, searchUrlToString } from "../../../../../scripts/helpers";
import { searchTypeOptions } from "../../../../../utils/component/fileManagers/searchFileManager/searchFileManager.index";

const dateOption: any = [
    { label: "همه زمان‌ها", payload: CalendarOptions.ALL_DAYS },
    { label: "امروز", payload: CalendarOptions.TODAY },
    { label: "دیروز", payload: CalendarOptions.YESTERDAY },
    { label: "۷ روز اخیر", payload: CalendarOptions.WEEK },
    { label: "۳۰ روز اخیر", payload: CalendarOptions.MONTH },
    { label: "بازه دلخواه", payload: CalendarOptions.CUSTOM }
];

const checkTypeOption = (type?: string) => searchTypeOptions.find((typeOption: any) => typeOption.payload === type);

const AdvancedSearch = ({ onClose, searchFilters, setSearchFilter, drawerStatus }: AdvencedSearchInterface) => {
    const [filter, setFilter] = useState(searchFilters);

    const navigate = useNavigate();
    const endDateListboxRef = useRef<any>();
    const startDateListboxRef = useRef<any>();
    const fileLocationListboxRef = useRef<any>();
    const [endDate, setEndDate] = useState<number>(moment().unix());
    const [startDate, setStartDate] = useState<number>(moment().unix());
    const [searchErrors, setSearchErrors] = useState<{ searchValue: string }>({ searchValue: "" });

    const checkDateOption = (option?: string) => {
        const optionTitle = dateOption.find((date: any) => date.payload === option);
        return optionTitle !== undefined ? optionTitle : { label: "همه زمان‌ها", payload: CalendarOptions.ALL_DAYS };
    };

    const handleChangeSearchValue = (value: string) => {
        if (value && value.length > 250) setSearchErrors({ ...searchErrors, searchValue: "تعداد کاراکتر بیش از حد مجاز است." });
        else {
            setSearchErrors({ ...searchErrors, searchValue: "" });
            setFilter({ ...filter, name: value || undefined });
        }
    };

    const handleSubmitForm = () => {
        onClose();
        const qs = searchUrlToString(filter);
        navigate(`${PATH.search}${qs}pageType:${SearchPageType.MY_FILE}`);
    };

    useEffect(() => {
        const keyboardEventListener = (e: any) => e.code === "Escape" && onClose();
        document.body.addEventListener("keydown", keyboardEventListener);
        return () => document.body.removeEventListener("keydown", keyboardEventListener);
    }, []);

    useEffect(() => {
        setFilter(searchFilters);
    }, [searchFilters]);

    return (
        <Drawer title="فیلترها" status={drawerStatus} onClose={onClose} closeOnBlur>
            <div className="flex-1 overflow-auto p-4">
                <div className="mb-4">
                    <TextInput
                        label="شامل کلمات"
                        placeholder="جستجوی نام فایل"
                        parentClassName="relative !w-full !text-right"
                        onChange={(value) => handleChangeSearchValue(value)}
                        value={filter.name || ""}
                        error={searchErrors.searchValue}
                        errorClassName="text-[11px] mt-1"
                    />
                </div>
                <div className="mb-4">
                    <Dropdown
                        options={searchTypeOptions}
                        value={checkTypeOption(filter?.type) || searchTypeOptions[0]}
                        onChange={(value) => setFilter({ ...filter, type: value.payload })}
                        title="نوع"
                        classNames="p-3 mt-1"
                    />
                </div>
                <div className="mb-4">
                    <Dropdown
                        options={dateOption}
                        value={checkDateOption(filter.dateOption)}
                        onChange={(value) => {
                            if (value.payload === CalendarOptions.CUSTOM) {
                                setFilter({
                                    ...filter,
                                    dateOption: value.payload,
                                    from_created_at: moment().startOf("day").subtract("2", "day").unix(),
                                    to_created_at: moment().unix(),
                                    range: true
                                });
                            } else {
                                const range = dateRangeCheck(value.payload);
                                setFilter({
                                    ...filter,
                                    dateOption: value.payload,
                                    range: false,
                                    from_created_at: range ? range[0] : undefined,
                                    to_created_at: range ? range[1] : undefined
                                });
                            }
                        }}
                        title="زمان"
                        classNames="p-3 mt-1"
                    />
                </div>
                {filter.range && (
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-4">
                        <div className="w-full mb-4">
                            <Listbox value={null} onChange={() => {}}>
                                <div>
                                    <Listbox.Label className="text-[14px]">از تاریخ</Listbox.Label>
                                    <Listbox.Button
                                        ref={startDateListboxRef}
                                        className={`relative w-full rounded-lg bg-white border-[1.5px] border-gray-100 text-left sm:text-sm p-3 mt-1`}
                                    >
                                        {({ open }) => (
                                            <div className="flex gap-4 items-center">
                                                <div className="flex items-center gap-2">
                                                    {moment.unix(filter.from_created_at || 0).format("jD jMMMM jYYYY")}
                                                </div>
                                                <span
                                                    className={`pointer-events-none mr-auto inset-y-0 transition-transform duration-500 ${open ? "rotate-0" : "rotate-180"}`}
                                                >
                                                    <CaretUp className="stroke-[#A0A3BD]" />
                                                </span>
                                            </div>
                                        )}
                                    </Listbox.Button>
                                    <Transition as={Fragment} leave="transition ease-in duration-100" leaveFrom="opacity-100" leaveTo="opacity-0">
                                        <div className="lg:absolute lg:left-0 w-full z-[10000] lg:px-4">
                                            <Listbox.Options
                                                className={`mt-1 p-2 w-full overflow-auto rounded-md bg-white drop-shadow-lg text-base ring-1 ring-black ring-opacity-5 sm:text-sm z-50 no-scrollbar`}
                                            >
                                                <Calendar
                                                    disableAfter={filter.to_created_at}
                                                    selectedDay={filter.from_created_at}
                                                    onChange={(date) => setStartDate(date)}
                                                />
                                                <div className="flex items-center gap-4">
                                                    <Button
                                                        className="w-full"
                                                        type={ButtonType.TEXT}
                                                        autoFocus={false}
                                                        text="انصراف"
                                                        onClick={() => startDateListboxRef.current.click()}
                                                    />
                                                    <Button
                                                        className="w-full"
                                                        text="تایید"
                                                        onClick={() => {
                                                            setFilter({ ...filter, from_created_at: startDate });
                                                            startDateListboxRef.current.click();
                                                        }}
                                                        autoFocus
                                                    />
                                                </div>
                                            </Listbox.Options>
                                        </div>
                                    </Transition>
                                </div>
                            </Listbox>
                        </div>
                        <div className="w-full mb-4">
                            <Listbox value={null} onChange={() => {}}>
                                <div>
                                    <Listbox.Label className="text-[14px]">تا تاریخ</Listbox.Label>
                                    <Listbox.Button
                                        ref={endDateListboxRef}
                                        className={`relative w-full rounded-lg bg-white border-[1.5px] border-gray-100 text-left sm:text-sm p-3 mt-1`}
                                    >
                                        {({ open }) => (
                                            <div className="flex gap-4 items-center">
                                                <div className="flex items-center gap-2">
                                                    {moment.unix(filter.to_created_at || 0).format("jD jMMMM jYYYY")}
                                                </div>
                                                <span
                                                    className={`pointer-events-none mr-auto inset-y-0 transition-transform duration-500 ${open ? "rotate-0" : "rotate-180"}`}
                                                >
                                                    <CaretUp className="stroke-[#A0A3BD]" />
                                                </span>
                                            </div>
                                        )}
                                    </Listbox.Button>
                                    <Transition as={Fragment} leave="transition ease-in duration-100" leaveFrom="opacity-100" leaveTo="opacity-0">
                                        <div className="lg:absolute lg:left-0 w-full z-[10000] lg:px-4">
                                            <Listbox.Options
                                                className={`mt-1 p-2 w-full overflow-auto rounded-md bg-white drop-shadow-lg text-base ring-1 ring-black ring-opacity-5 sm:text-sm z-50 no-scrollbar`}
                                            >
                                                <Calendar
                                                    disableBefore={filter.from_created_at}
                                                    selectedDay={filter.to_created_at}
                                                    onChange={(date) => setEndDate(date)}
                                                />
                                                <div className="flex items-center gap-4">
                                                    <Button
                                                        className="w-full"
                                                        type={ButtonType.TEXT}
                                                        autoFocus={false}
                                                        text="انصراف"
                                                        onClick={() => endDateListboxRef.current.click()}
                                                    />
                                                    <Button
                                                        className="w-full"
                                                        text="تایید"
                                                        onClick={() => {
                                                            setFilter({ ...filter, to_created_at: endDate });
                                                            endDateListboxRef.current.click();
                                                        }}
                                                        autoFocus
                                                    />
                                                </div>
                                            </Listbox.Options>
                                        </div>
                                    </Transition>
                                </div>
                            </Listbox>
                        </div>
                    </div>
                )}
                <div className="w-full mb-4">
                    <Listbox value={null} onChange={() => {}}>
                        <div>
                            <Listbox.Label className="text-[14px]">مکان</Listbox.Label>
                            <Listbox.Button
                                ref={fileLocationListboxRef}
                                className={`relative w-full rounded-lg bg-white border-[1.5px] border-gray-100 text-left sm:text-sm p-3 mt-1`}
                            >
                                {({ open }) => (
                                    <div className="flex gap-4 items-center">
                                        <div className="flex items-center gap-2">
                                            {filter.parent_name && filter.parent_name !== "null" ? filter.parent_name : "فایل‌های من"}
                                        </div>
                                        <span
                                            className={`pointer-events-none mr-auto inset-y-0 transition-transform duration-500 ${open ? "rotate-0" : "rotate-180"}`}
                                        >
                                            <CaretUp className="stroke-[#A0A3BD]" />
                                        </span>
                                    </div>
                                )}
                            </Listbox.Button>
                            <Transition as={Fragment} leave="transition ease-in duration-100" leaveFrom="opacity-100" leaveTo="opacity-0">
                                <div className="lg:absolute lg:left-0 w-full z-[10000] lg:px-4">
                                    <Listbox.Options
                                        className={`mt-1 p-2 w-full overflow-auto rounded-md bg-white drop-shadow-lg text-base ring-1 ring-black ring-opacity-5 sm:text-sm z-50 no-scrollbar`}
                                    >
                                        <FolderLocationModal
                                            showFolderLocationModal
                                            setShowFolderLocationModal={() => true}
                                            handleGetFolderLocation={(id, name) => {
                                                setFilter({ ...filter, parent_name: name, parent_id: id });
                                                fileLocationListboxRef.current.click();
                                            }}
                                            isModal={false}
                                        />
                                    </Listbox.Options>
                                </div>
                            </Transition>
                        </div>
                    </Listbox>
                </div>
                <div className="ml-auto flex items-center justify-start gap-4">
                    <CheckBox
                        label="سطل زباله"
                        onChange={(value: boolean) => setFilter({ ...filter, is_trash: value })}
                        defaultValue={filter.is_trash || false}
                    />
                    <CheckBox
                        label="علاقه‌مندی‌ها"
                        onChange={(value: boolean) => setFilter({ ...filter, is_favorite: value })}
                        defaultValue={filter.is_favorite || false}
                    />
                </div>
            </div>
            <div>
                <div className="flex items-center justify-between gap-4 p-4">
                    {/* mobile */}
                    <Button
                        className="flex-1 lg:hidden"
                        type={ButtonType.TEXT}
                        autoFocus={false}
                        text="حذف فیلترها"
                        onClick={() => {
                            setFilter({});
                            setSearchFilter({});
                            onClose();
                        }}
                    />
                    {/* desktop */}
                    <Button
                        className="hidden lg:flex flex-1"
                        type={ButtonType.TEXT}
                        autoFocus={false}
                        text="انصراف"
                        onClick={() => {
                            setFilter(searchFilters);
                            onClose();
                        }}
                    />
                    <Button className="flex-1" text="جستجو" onClick={handleSubmitForm} autoFocus />
                </div>
            </div>
        </Drawer>
    );
};

export default AdvancedSearch;
